module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "pager"
  }, [_c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "12em",
      "text-align": "center"
    }
  }, [_c('h2', [_vm._v("AfiaApp"), _c('br'), _vm._v("Chat & Buy")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "2em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "margin": "1em"
    },
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("login")]), _vm._v(" | \r\n                    "), _c('a', {
    staticClass: "btn sp-button-1",
    staticStyle: {
      "margin": "1em"
    },
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("signup")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ac235d2"}!./src/pages/Home/template.html
// module id = 416
// module chunks = 0